import { SECONDS_PER_MINUTE } from "../constants/approval";

// NOTE: Sub-minute runs keep a decimal, since a webhook that took 0.4s and one
// that took 3s are meaningfully different: 0.4 → "0.4s", 95 → "1m 35s".
export const formatRunDurationSeconds = (durationSec: number): string => {
  // NOTE: Round the total before splitting it. Rounding the remainder on its own
  // renders durations that cannot exist: 119.6 as "1m 60s", 59.96 as "60.0s".
  const totalSeconds = Math.round(durationSec);

  if (totalSeconds < SECONDS_PER_MINUTE) {
    return `${durationSec.toFixed(1)}s`;
  }

  const minutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE);
  const seconds = totalSeconds % SECONDS_PER_MINUTE;
  return `${minutes}m ${seconds}s`;
};
